import {Routes} from '@angular/router';
import {guestGuard} from '@app/auth/guards';
import {companyConfigGuard} from '@compliants-client/guards';

export const authRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@auth/pages/login/login').then(m => m.Login),
    canActivate: [guestGuard]
  },
  {
    path: 'compliants/client/:companyId',
    loadComponent: () => import('@layouts/compliants-layout/compliants-layout').then(m => m.CompliantsLayout),
    canActivate: [companyConfigGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        loadComponent: () => import('@auth/pages/login-complaints/login-complaints').then(m => m.LoginComplaints),
        canActivate: [guestGuard]
      }
    ]
  },
  {
    path: 'login/alternate',
    loadComponent: () => import('@auth/pages/alternate-login/alternate-login').then(m => m.AlternateLogin),
    canActivate: [guestGuard]
  },
  {
    path: 'employee-access-invitations/:token',
    loadComponent: () => import('@auth/pages/employee-access-invitation-manage/employee-access-invitation-manage').then(m => m.EmployeeAccessInvitationManage)
  }
];
